import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import {createRef, useContext, useEffect, useState} from "react";
import {ButtonGroup, Card, CardContent, Typography} from "@mui/material";
import Meta from "../common/Meta";
import moment from "moment";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import CalendarPane from "../dashboard/CalendarPane";
import EventsMiniDataTable from "../client/pane/EventsMiniDataTable";
import {getCookie, setCookie} from "../common/appCookie";
import MDButton from "../../components/MDButton";
import {pollAsyncEvents} from "../common/api/WebApi";
import FadeComponent from "../userinterface/FadeComponent";

export default function Events(props) {

  const location = useLocation();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [specialEvents, setSpecialEvents] = useState(props?.specialEvents);
  const [eventIndex, setEventIndex] = useState(1);

  useEffect(() => {
    setSpecialEvents(props?.specialEvents);
  }, [props?.specialEvents]);

  const calendarRef = createRef();

  const [context, setContext] = useContext(AppContext);
  const [initialLoad, setInitialLoad] = useState(true);
  const [calendarView, setCalendarView] = useState(getCookie('calendarView') || false);

  const [notice, setNotice] = useState(null);
  const [fadeNotice, setFadeNotice] = useState(false);
  useEffect(() => {
    if (searchParams.get('notice')) {
      setNotice(searchParams.get('notice'));
    }
  }, [searchParams]);

  const pollAsyncEventsFn = async () => {
    pollAsyncEvents(notice).then((resp) => {
      if (resp?.guid?.length > 0) {
        setEventIndex(eventIndex + 1);
        const intervalId = setInterval(() => {
          setFadeNotice(true);
        }, 300);
        const intervalId2 = setInterval(() => {
          setNotice(null);
        }, 500);
        return () => clearInterval(intervalId) && clearInterval(intervalId2);

      }
    })
  }

  useEffect(() => {
    if (notice) {
      const intervalId = setInterval(() => {
        pollAsyncEventsFn();
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [notice])

  const toggleMonthView = () => {
    setCookie('calendarView', !calendarView, 1);
    setCalendarView(!calendarView);
  }

  const addInventoryEventFn = (eventDate) => {
    let formattedDate = '';
    if (eventDate) {
      formattedDate = '?initDate=' + moment(eventDate || new Date()).format('YYYY-MM-DD HH:mm Z');
    }
    navigate('/sales/create/' + (specialEvents ? 'party' : 'event') + formattedDate);
  }

  return (

    <DashboardLayout>
      <Meta pageTitle={specialEvents ? 'Parties' : 'Events'}/>
      <ContextSearchNavbar title={specialEvents ? 'Parties' : 'Events'}/>
      <MDBox py={3}>
        <MDBox mb={3}>

          <FadeComponent show={notice} doFadeOut={fadeNotice}>
            {notice && <MDBox
              sx={{
                backgroundColor: "#333",
                color: "#fff",
                borderRadius: 1,
                px: 1,
                py: 1.5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: '100%',
                boxShadow: 2,
                marginBottom: '20px'
              }}
            >
              <Typography align="center" fontSize={"16px"}>
                We are saving your events. You may continue working or this page will refresh when finished.
              </Typography>
            </MDBox>}
          </FadeComponent>
          <Card>
            <CardContent>

              <ButtonGroup
                color="info"
                variant="contained"
                size="small"
                aria-label="Basic button group" className={'pull-right'}>

                <MDButton
                  size="small"
                  key={'addinventory'}
                  onClick={(e) => {
                    addInventoryEventFn(new Date());
                  }}>
                  <span className={'fa fa-plus'}></span>&nbsp;Add New {specialEvents ? 'Party ' : 'Event'}
                </MDButton>

                <MDButton
                  size="small"
                  key={'toggleview'}
                  onClick={(e) => {
                    toggleMonthView();
                  }}>
                  <span className={'fa fa-calendar'}></span>&nbsp;{calendarView ? 'Grid' : 'Calendar'} View
                </MDButton>
              </ButtonGroup>
              {eventIndex && <>
                {specialEvents && <>
                  {!calendarView && <EventsMiniDataTable specialEvents={true} key={eventIndex}/>}
                  {calendarView && <CalendarPane specialEvents={true} key={eventIndex}/>}
                </>}
                {!specialEvents && <>
                  {!calendarView && <EventsMiniDataTable specialEvents={false} key={eventIndex}/>}
                  {calendarView && <CalendarPane specialEvents={false} key={eventIndex}/>}
                </>}
              </>}


            </CardContent>
          </Card>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  );
}